const Getters = {
  getJdproductListFromState: (state) => {
    return state.jdproductList
  },
  getJdproductMetaFromState: (state) => {
    return state.meta
  },
  getRelatedProductList: (state) => (exProductNumber, platformId) => {
    const foundJdproduct = state.jdproductList.find((item) => {
      return (
        item.exProductNumber === exProductNumber &&
        item.platformId === platformId
      )
    })
    if (foundJdproduct) {
      foundJdproduct.exProductRelatedProductList.map(
        (item) => (item.exProductNumber = exProductNumber)
      )
      return foundJdproduct.exProductRelatedProductList
    } else {
      return []
    }
  },
  getJdproductMapFromState: (state) => {
    return state.jdproductMap
  }
}

export default Getters
